import { ComponentRoute } from '@/classes'

const OutstandingCreditRoutes = {
  OutstandingCreditListView: new ComponentRoute('/outstandingcredit', 'OutstandingCreditListView')
}

export default OutstandingCreditRoutes